<div class="signup-summary">
    <div class="signup-summary-title">{{ 'SIGNUP_COMMAND_SUMMARY' | translate }}</div>
    <div class="signup-summary-container"
        *ngIf="computedPlan">
        <div class="signup-summary-line bold">
            <div>{{ selectedPlan.name }} - {{ computedPlan | planDurationInYearOrMonth }}</div>
            <div class="signup-content-right-plan-price">
                <div>{{ startingPrice | priceFormater : {language, currency: selectedPlan.currency} }}</div>
            </div>
        </div>
        <ng-container *ngIf="smashPremiumDiscount && smashPremium1month">
            <div class="signup-summary-value">
                <div></div>
                <div></div>
                <div>
                    <div class="light-grey">{{ 'SIGNUP_TANTAMOUNT' | translate }} {{ smashPremium1month?.priceExclTax |
                        priceFormater : {language, currency: selectedPlan.currency} }} x {{ computedPlan |
                        planDurationInMonth }}</div>
                </div>
            </div>
            <div class="signup-summary-value ">
                <div>{{ 'SIGNUP_SALE' | translate }} ({{smashPremiumDiscount}}%)</div>
                <div>
                    <div class="discount-amount bold">- {{startingPrice - computedPlan.priceExclTax | priceFormater :
                        {language, currency: selectedPlan.currency} }} </div>
                </div>
            </div>
            <div class="signup-summary-separator"></div>
            <div class="signup-summary-line bold">
                <div>{{ 'SIGNUP_TOTAL_BEFORE_TAX' | translate }}</div>
                <div class="signup-content-right-plan-price">
                    <div>{{ computedPlan.priceExclTax | priceFormater : {language, currency: selectedPlan.currency} }}
                    </div>
                </div>
            </div>
            <div class="signup-summary-value">
                <div></div>
                <div></div>
                <div>
                    <div class="light-grey">{{ 'SIGNUP_TANTAMOUNT' | translate }} {{ priceFormatted }} x {{ computedPlan
                        | planDurationInMonth }}</div>
                </div>
            </div>
        </ng-container>
        <div class="signup-summary-line">
            <div>{{ 'SIGNUP_VAT' | translate }} ({{computedPlan.percent}}%)</div>
            <div>
                <div>{{computedPlan.priceDiff | priceFormater : {language, currency: selectedPlan.currency} }} </div>
            </div>
        </div>
        <div class="signup-summary-separator"></div>
        <div class="signup-summary-line bold">
            <div>{{ 'SIGNUP_TOTAL' | translate }}</div>
            <div>
                <div>{{computedPlan.priceInclTax | priceFormater : {language, currency: selectedPlan.currency} }} </div>
            </div>
        </div>
        <ng-container *ngIf="!smashPremiumDiscount && smashPremium1month && sale1year">
            <div class="save-on-smash">{{ 'SIGNUP_SALE_OFFER_BLOCK_1' | translate: { sale1year } }}<span
                    (click)="selectOffer('1years')"
                    class="link">{{ 'SIGNUP_SALE_OFFER_BLOCK_1_LABEL' | translate }}</span>{{
                'SIGNUP_SALE_OFFER_BLOCK_2' | translate: { sale2years } }}<span (click)="selectOffer('2years')"
                    class="link">{{ 'SIGNUP_SALE_OFFER_BLOCK_2_LABEL' | translate }}</span>
            </div>
        </ng-container>
    </div>
</div>